import { defineAction } from '~/prix'
import residenceAllocateCommunityAction from './residenceAllocateCommunity.action.json' with { type: 'json' }
import { z } from 'zod'

const residenceAllocateCommunityDefinition = defineAction({
  ...residenceAllocateCommunityAction,

  input: z.object({
    clientId: z.number().optional().describe('ID do cliente específico para processar '), //opcional
  }),
  output: z.object({
    message: z.string(),
    stats: z.object({
      totalResidences: z.number(),
      allocatedDirectly: z.number(),
      allocatedByProximity: z.number(),
      totalAllocated: z.number(),
      stillUnallocated: z.number(),
    }),
    communityDistribution: z
      .array(
        z.object({
          communityName: z.string(),
          residenceCount: z.number(),
        }),
      )
      .optional(),
  }),
})

export default residenceAllocateCommunityDefinition
